var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import Typography from '../Typography';
import FormControlHelpText from './FormControlHelpText';
const FormControlSC = styled.div `
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${(p) => p.theme.SizeMarginInputBottom};
  font-family: ${(p) => p.theme.FontFamilyBase};

  ._ndsFormControl__label {
    user-select: none;
    margin-bottom: 0.25rem;
    color: ${(p) => p.theme.ColorFontInputLabelBase};
  }

  ._ndsFormControl__label__input,
  ._ndsFormControl__label__optional {
    color: inherit;
  }

  ._ndsFormControl__label__optional {
    margin-left: 0.5rem;
  }

  /* hover */
  &:hover {
    ._ndsFormControl__label__input {
      color: ${(props) => props.theme.ColorFontInputLabelHover};
    }
  }

  /* disabled */
  &._ndsFormControl--disabled {
    user-select: none;
    ._ndsFormControl__label__input,
    ._ndsFormControl__label__optional {
      color: ${(props) => props.theme.ColorFontInputLabelDisabled};
    }
  }

  /* error */
  &._ndsFormControl--error {
    ._ndsFormControl__label__input {
      color: ${(props) => props.theme.ColorFontInputLabelError};
    }
  }

  /* disabled & error */
  &._ndsFormControl--disabled._ndsFormControl--error {
    ._ndsFormControl__label__optional {
      color: inherit;
    }
  }

  &._ndsFormControl--fullWidth {
    display: flex;
    align-items: stretch;
    width: 100%;
  }
`;
const FormControl = (props) => {
    const { label, helpTextId, children, forwardedRef, className: classNameProp, disabled, error, required, fullWidth, inputId, helpText } = props, others = __rest(props, ["label", "helpTextId", "children", "forwardedRef", "className", "disabled", "error", "required", "fullWidth", "inputId", "helpText"]);
    const classes = clsx('_ndsFormControl', { '_ndsFormControl--error': error === true }, { '_ndsFormControl--disabled': disabled === true }, { '_ndsFormControl--fullWidth': fullWidth === true }, classNameProp);
    return (React.createElement(FormControlSC, Object.assign({ ref: forwardedRef, className: classes }, others),
        React.createElement("div", { className: "_ndsFormControl__label" },
            React.createElement(Typography, { as: "label", htmlFor: inputId, className: "_ndsFormControl__label__input", variant: "subhead1" }, label),
            !required && (React.createElement(Typography, { as: "label", className: "_ndsFormControl__label__optional", variant: "body4" }, "Optional"))),
        children,
        React.createElement(FormControlHelpText, { helpText: helpText, helpTextId: helpTextId, error: error, disabled: disabled })));
};
FormControl.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    forwardedRef: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    required: PropTypes.bool,
    fullWidth: PropTypes.bool,
    inputId: PropTypes.string,
    helpTextId: PropTypes.string,
    label: PropTypes.string,
    helpText: PropTypes.any
};
FormControl.defaultProps = {
    label: undefined,
    helpText: undefined,
    forwardedRef: React.createRef(),
    className: undefined,
    disabled: false,
    error: false,
    fullWidth: false,
    required: false,
    inputId: undefined,
    helpTextId: undefined
};
export default withForwardedRef(FormControl);
//# sourceMappingURL=FormControl.js.map